export default (clipboardContents: string) => {
  if (
    !(
      (clipboardContents.startsWith("{") && clipboardContents.endsWith("}")) ||
      (clipboardContents.startsWith("[") && clipboardContents.endsWith("]"))
    )
  )
    return;

  try {
    const json = JSON.parse(clipboardContents);

    if (
      !(
        json.tagName ||
        (Array.isArray(json) &&
          json.filter((item) => !item.tagName).length === 0)
      )
    )
      return;

    return json;
  } catch (error) {
    return;
  }
};
